import { Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const PageNotFound = ({ text }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ textAlign: "center", my: 8, mx: 2 }}>
      <Typography variant="h4">{text ?? "Page Not Found"}</Typography>
      <Button
        variant="text"
        color="primary"
        sx={{ mt: 2 }}
        onClick={() => navigate("/")}
        startIcon={<ArrowBackIcon />}
      >
        Back to Home
      </Button>
    </Box>
  );
};

export default PageNotFound;
